export default {"src":"/_next/static/media/GooglePlayStore.24865bd7.svg","height":50,"width":172,"blurWidth":0,"blurHeight":0};